module.exports = __webpack_public_path__ + "media/images/font/Gustavo-ThinItalic-7054db0568fb858d01dc85aff5b1cf98.woff";